import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMegaphone",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, p, _, e) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--megaphone"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Megaphone",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.803 2.602A.5.5 0 0 1 11 3v6a.5.5 0 0 1-.608.488L6.27 8.572a2.004 2.004 0 0 1-3.903-.867l-.976-.217A.5.5 0 0 1 1 7V5.5a.5.5 0 0 1 .366-.482l9-2.5a.5.5 0 0 1 .437.084ZM3.349 7.923a1.004 1.004 0 0 0 1.94.431l-1.94-.431ZM2 5.88v.72l8 1.778v-4.72L2 5.88Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ s(c, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=megaphone.js.map
